import React, { useEffect, useState } from "react";
import {
  ContainerTab,
  FormControlLabelStyled,
  Row,
  TextFieldSearchStyled,
} from "../../styles";
import Field from "../../components/Field";
import {
  InputDateForm,
  InputForm,
} from "../../../../../components/Modal/Input";
import {
  findAllConvenio,
  findAllProfissionalSaudeComAgenda,
  findProfissionalSaudeByUnidadeSemAgenda,
} from "../../../../../services/InternacaoService";
import { ReactSelect } from "../../../../../components/Select/SelectSearch";
import { tiposEncaminhamentos } from "../../constants";
import { Checkbox } from "@material-ui/core";

const DadosComplementares = ({ internacao, handleField, listInternacoes }) => {
  const { dadosComplementares } = internacao;
  const {
    ambulante,
    convenio,
    dataGuia,
    encaminhamento,
    numeroGuia,
    observacoesGerais,
    observacoesMedico,
    profissionalAtendente,
    profissionalSolicitante,
    transferido,
    senha,
    dataValidadeSenha,
  } = dadosComplementares || {};

  const unidadeLogada = JSON.parse(localStorage["_immortal|unidadeLogada"]);

  const [profissionaisResponsavel, setProfissionaisResponsavel] = useState([]);

  useEffect(() => {
    getProfissionaisResponsavel();

  }, []);

  const handleFieldDadosComplementares = (value, field) => {
    const dadosComplementares = internacao.dadosComplementares;
    dadosComplementares[field] = value;

    handleField("dadosComplementares", dadosComplementares);
  };

  const loadAllConvenio = async (search, loadedOptions, { page }) => {
    const searchDTO = {
      search,
      pageNumber: page,
      pageSize: 20,
      sortDir: "ASC",
      sortField: "descricao",
    };

    const response = await findAllConvenio({ searchDTO });
    const { content, last } = response;

    const removeConveniosListInternacoes = content.filter(
      (convenio) => !listInternacoes.some((internacao) => internacao.dadosComplementares?.convenio.id === convenio.id)
    );

    return {
      options: removeConveniosListInternacoes,
      hasMore: !last,
      additional: {
        page: page + 1,
      },
    };
  };

  const getProfissionaisResponsavel = async () => {
    try {
      const variables = {
        pageableDTO: {
          sortDir: "ASC",
          sortField: "nome",
        },
        unidadeId: unidadeLogada.id,
      };
  
      const response = await findProfissionalSaudeByUnidadeSemAgenda(variables);
      setProfissionaisResponsavel(response);

    } catch (error) {
      console.error(error)
    }
  }

  const loadAllProfissionalExternoComAgenda = async (
    search,
    loadedOptions,
    { page }
  ) => {
    const variables = {
      search,
      pageableDTO: {
        pageNumber: page,
        pageSize: 20,
        sortDir: "ASC",
        sortField: "nome",
      },
      unidadeId: unidadeLogada.id,
      ativo: true,
      externos: true,
    };

    const response = await findAllProfissionalSaudeComAgenda(variables);
    const { content, last } = response;

    return {
      options: content,
      hasMore: !last,
      additional: {
        page: page + 1,
      },
    };
  };

  return (
    <ContainerTab>
      <Row>
        <Field label="Convênio" width="80%">
          <TextFieldSearchStyled
            id="agd-dco-sel-cnv"
            placeholder="Selecione"
            loadOptions={loadAllConvenio}
            getOptionLabel={(option) => option.descricao}
            getOptionValue={(option) => option.id}
            value={convenio}
            onChange={(e) => handleFieldDadosComplementares(e, "convenio")}
            withPaginate
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
          />
        </Field>
      </Row>
      <Row>
        <Field label="Guia">
          <InputForm
            id="agd-dco-inp-gui"
            value={numeroGuia}
            type="number"
            onChange={(e) =>
              handleFieldDadosComplementares(e.target.value, "numeroGuia")
            }
          />
        </Field>
        <Field label="Data guia">
          <InputDateForm
            id="agd-dco-inp-dtg"
            value={dataGuia}
            onChange={(e) => handleFieldDadosComplementares(e, "dataGuia")}
          />
        </Field>
        <Field label="Senha">
          <InputForm
            id="agd-dco-inp-sen"
            value={senha}
            onChange={(e) =>
              handleFieldDadosComplementares(e.target.value, "senha")
            }
          />
        </Field>
        <Field label="Data validade senha">
          <InputDateForm
            id="agd-dco-inp-dvs"
            value={dataValidadeSenha}
            invalidDateMessage=""
            onChange={(e) => handleFieldDadosComplementares(e, "dataValidadeSenha")}
          />
        </Field>
      </Row>
      <Row>
        <Field label="Profissional Solicitante">
          <TextFieldSearchStyled
            id="agd-dco-sel-prs"
            placeholder="Selecione"
            loadOptions={loadAllProfissionalExternoComAgenda}
            getOptionLabel={(option) => option.nome}
            getOptionValue={(option) => option.id}
            value={profissionalSolicitante}
            onChange={(e) =>
              handleFieldDadosComplementares(e, "profissionalSolicitante")
            }
            withPaginate
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
          />
        </Field>
      </Row>
      <Row>
        <Field label="Transferido">
          <InputForm
            id="agd-dco-inp-trf"
            value={transferido}
            onChange={(e) =>
              handleFieldDadosComplementares(e.target.value, "transferido")
            }
          />
        </Field>
      </Row>
      <Row>
        <Field label="Obs geral">
          <InputForm
            id="agd-dco-inp-obg"
            value={observacoesGerais}
            onChange={(e) =>
              handleFieldDadosComplementares(
                e.target.value,
                "observacoesGerais"
              )
            }
          />
        </Field>
      </Row>
      <Row>
        <Field label="Obs médico">
          <InputForm
            id="agd-dco-inp-obm"
            value={observacoesMedico}
            onChange={(e) =>
              handleFieldDadosComplementares(
                e.target.value,
                "observacoesMedico"
              )
            }
          />
        </Field>
      </Row>
      <Row>
        <Field label="Funcionária Responsável">
          <ReactSelect
            id="agd-dco-sel-pra"
            value={profissionalAtendente}
            onChange={(e) =>
              handleFieldDadosComplementares(e, "profissionalAtendente")
            }
            getOptionLabel={(option) => option.nome}
            getOptionValue={(option) => option.id}
            options={profissionaisResponsavel}
            menuPlacement="auto"
          />
        </Field>
      </Row>
      <Row>
        <FormControlLabelStyled
          control={
            <Checkbox
              id="agd-dco-chk-amb"
              checked={ambulante}
              color="primary"
              onChange={() =>
                handleFieldDadosComplementares(!ambulante, "ambulante")
              }
            />
          }
          label="Ambulante"
        />
        <Field label="Encaminhado para" width="20%">
          <ReactSelect
            id="agd-dco-sel-enc"
            value={encaminhamento}
            onChange={(e) =>
              handleFieldDadosComplementares(e, "encaminhamento")
            }
            options={tiposEncaminhamentos}
            menuPlacement="auto"
          />
        </Field>
      </Row>
    </ContainerTab>
  );
};

export default DadosComplementares;
